import {useEffect, useState} from 'react';
import CatchDefaultTemplate from '@/components/main/MyPlus/common/TemplateType/CatchDefaultTemplate';
import {CATEGORY_SLICE_CNT} from '@/constants/main';

const CatchContentType = ({
  data,
  selectedMode,
  hiddenStreamer,
  onChangeEnabled,
  log,
}) => {
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
    if (data) {
      const filteredList = data
        .filter(
          (item) =>
            !hiddenStreamer.includes(item.originalUserId ?? item.userId),
        )
        .slice(0, CATEGORY_SLICE_CNT);

      if (filteredList.length < 10) {
        onChangeEnabled(false);
      } else {
        onChangeEnabled(true);
      }

      const transformedList = filteredList.map((catchItem) => {
        const {
          thumb,
          titleNo,
          resolutionType,
          titleName,
          viewCnt,
          bjId,
          thumbH,
          ...rest
        } = catchItem;

        const isHorizontal = resolutionType === 'horizontal';

        return {
          ...catchItem,
          catchId: titleNo,
          thumbnailSrc: isHorizontal ? thumb : thumbH,
          isHorizontal: isHorizontal,
          viewCount: viewCnt || 0,
          title: titleName,
          userId: bjId,
        };
      });

      setItemList([...transformedList]);
    }
  }, [data, hiddenStreamer]);

  return (
    <>
      <CatchDefaultTemplate
        itemList={itemList}
        selectedMode={selectedMode}
        log={log}
      />
    </>
  );
};
export default CatchContentType;
